/**
 * @description
 * Check if two objects are exactly the same through their properties. Does not include internal comparison of objects
 * @param {object} object1 first Object
 * @param {object} object2 second Object
 *
 * @returns {boolean} is Equal or Not
 *
 * @example
 * shallowEqual({name: 'Juan'}, {name: 'Juan'}) //returns true
 * shallowEqual({name: 'Juan'}, {name: 'Pedro'}) //returns false
 * shallowEqual({name: 'Juan', pet: { name: 'Michi'}}, {name: 'Juan', pet: { name: 'Michi'}}) //returns false
 */
export function shallowEqual(object1, object2) {
  const keys1 = Object.keys(object1);
  const keys2 = Object.keys(object2);

  if (keys1.length !== keys2.length) {
    return false;
  }

  for (let key of keys1) {
    if (object1[key] !== object2[key]) {
      return false;
    }
  }

  return true;
}
